import axios from 'axios';
import { from } from 'rxjs';

export const notifyMarketplace = (fulfillmentIds) => {
  const getAndTransform = axios.post('/marketplace/sendShipmentNotifications', { fulfillmentIds }).then((response) => {
    return response;
  });
  return from(getAndTransform);
};

export const notifyMarketplaceAsync = (fulfillmentIds) => {
  const getAndTransform = axios.post('/marketplace/sendShipmentNotificationsAsync', { fulfillmentIds }).then((response) => {
    return response;
  });
  return from(getAndTransform);
};

export const sendNotificationsAsync = (fulfillmentIds) => {
  const getAndTransform = axios.post('fulfillment/notification/sendAsync', { fulfillmentIds }).then((response) => {
    return response;
  });
  return from(getAndTransform);
};
